import { Dropdown, DropdownProps } from '../../components/Dropdown'

export const MethodSubTypeDropdown = (props: DropdownProps) => {
  const onTableItemPress = () => {
    props.setFieldValue('bankId', '' as any)
    props.setFieldValue('cardScheme', '' as any)
    props.setFieldValue('cardType', '' as any)
  }

  return <Dropdown {...props} onTableItemPress={onTableItemPress} />
}
